import { atom } from 'jotai';

export const navigationModalOpenAtom = atom(false);
